import { Box } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { AliceCardFragment } from '@alice-financial/alice-sdk'
import { StripeElementPlaceholder } from '../stripe/StripeElementPlaceholder'
import { useWalletButton } from '../stripe/useWalletButton'
import { useSupportsApplePay } from '../../../../../utils/useSupportsApplePay'
import { useStripeConnectedAccountId } from '../stripe/useStripeConnectedAccountId'
import { WalletButtonLoadingState } from '../stripe/WalletButtonLoadingState'

type WalletProvisioningButtonProps = {
  card: AliceCardFragment
}

/**
 * Component that renders the Stripe "Add to Apple Wallet" button on the main cards page.
 * Only visible on Apple devices (iOS, iPadOS, macOS) when the instant card is not connected to a digital wallet.
 */
export const WalletProvisioningButton = ({ card }: WalletProvisioningButtonProps) => {
  const supportsApplePay = useSupportsApplePay()
  const { stripeAccount } = useStripeConnectedAccountId()

  const { mountButton, isLoading } = useWalletButton({
    card,
    stripeAccount,
  })

  // Don't render if not on Apple device or if card is already connected to digital wallet
  if (!supportsApplePay || card.isConnectedToDigitalWallet || !stripeAccount) {
    return null
  }

  // Show loading state while button is being prepared
  if (isLoading) {
    return <WalletButtonLoadingState withBottomMargin />
  }

  return (
    <Box display="flex" justifyContent="center" mb={4}>
      <StripeElementPlaceholder mount={mountButton} id="add-to-apple-wallet-main" />
    </Box>
  )
}

